import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/BreakdownReasonDetailActions";
import * as api from "../../api/BreakdownReasonDetailApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getBreakdownReasonDetails(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownReasonDetails(action.payload);
        yield put(actions.setBreakdownReasonDetails(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonDetails(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addBreakdownReasonDetail(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addBreakdownReasonDetail(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateBreakdownReasonDetail(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateBreakdownReasonDetail(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteBreakdownReasonDetail(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteBreakdownReasonDetail(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonGroups() {
    try {
        const { data } = yield api.getBreakDownReasonGroups();
        yield put(actions.setBreakDownReasonGroups(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownPlaceByGroupId(action) {
    try {
        const { data } = yield api.getBreakdownReasonPlaceByGroupId(action.payload);
        yield put(actions.setBreakdownReasonPlaceByGroupId(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_DETAILS, getBreakdownReasonDetails);
    yield takeEvery(actions.Types.ADD_BREAKDOWN_REASON_DETAIL, addBreakdownReasonDetail);
    yield takeEvery(actions.Types.UPDATE_BREAKDOWN_REASON_DETAIL, updateBreakdownReasonDetail);
    yield takeEvery(actions.Types.DELETE_BREAKDOWN_REASON_DETAIL, deleteBreakdownReasonDetail);
    yield takeEvery(actions.Types.GET_PLANTS, getPlants);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_GROUPS, getBreakDownReasonGroups);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_PLACE_BY_ID, getBreakDownPlaceByGroupId);
}

const BreakdownReasonDetailSaga = [fork(watchAll)];

export default BreakdownReasonDetailSaga;
